import {useUser} from '@auth0/nextjs-auth0/client'
import {useEffect} from 'react'

import env from 'lib/config/public-env'
import {localUser, logoutOnce} from 'lib/user'

function useLocalUser() {
  return {
    isLoading: false,
    user: localUser
  }
}

function useConveyalUser() {
  const response = useUser()

  /**
   * If a user is on a page for long enough their session may expire. In the case there is an error
   * retrieving their user profile or there is no user object and the session is not still loading
   * then that indicates their session is now invalid. Auto-log them out.
   */
  useEffect(() => {
    if (response.error || (!response.user && !response.isLoading)) {
      logoutOnce(response.error, response.user)
    }
  }, [response.error, response.isLoading, response.user])

  return {
    ...response,
    user: response?.user ? (response.user as unknown as CL.User) : localUser
  }
}

export default env.AUTH_DISABLED ? useLocalUser : useConveyalUser
